
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.53 13.097a.999.999 0 00-.72-.31h-1.55a7.75 7.75 0 001.6-5.65 1 1 0 00-1.11-.87 8 8 0 00-6.78 6.52h-7.83l-1-7.91a1 1 0 00-1.482-.747 1 1 0 00-.498.997l1 7.66H20a.999.999 0 00-.72.31 1 1 0 00-.28.72l.14 4.81a.912.912 0 000 .17l.34 11.48a1 1 0 00.29.68 3.7 3.7 0 011.14 3.06l.49 20.07a1 1 0 001 1h15.08a1 1 0 001-1l.43-20.07a1.765 1.765 0 010-.23 3.55 3.55 0 011.1-2.79 1 1 0 00.29-.68l.49-16.46a1 1 0 00-.26-.76zm-2.62-4.59a5.87 5.87 0 01-2.48 4.28h-1.37a6.05 6.05 0 013.85-4.28zm-14.64 6.28H38.8l-.06 2.09c-1.28.4-4.5.75-9.19-.14a18.57 18.57 0 00-8.45.63l-.08-2.58h2.25zm-.36 19.23v-.22a3 3 0 013-2.89 3 3 0 013 2.89v19.27h-5.58l-.42-19.05zm13.59 19.07h-5.59v-19.32a3 3 0 013-2.89 3 3 0 013 2.87v.26l-.41 19.08zm-2.59-24.21a5 5 0 00-4 2 5 5 0 00-4-2 5 5 0 00-3.82 1.76 6 6 0 00-.6-.8l-.31-10.39a17.102 17.102 0 018-.75 25 25 0 009.5.27l-.33 10.87c-.22.248-.42.512-.6.79a5.001 5.001 0 00-3.84-1.75z"}})])
          )
        }
      }
    